import React from 'react';
import { UserExperienceDto } from '@apply/api/src/api/ApplyApi';
import { isMobileScreen } from '@apply/ui';
import { ExperienceType } from '@apply/constants';

export interface VerifiedCountProps {
    verifiedExperience: UserExperienceDto[];
}

export const VerifiedCount: React.FC<VerifiedCountProps> = ({ verifiedExperience }) => {
    const mobileScreen = isMobileScreen();
    const propertyVerified = 'Property Verified';
    const propertiesVerified = 'Properties Verified';

    const count = verifiedExperience.length;
    const nonBFIVerifiedCount = verifiedExperience.filter((n) => n.experienceTypeId == ExperienceType.NonBfi).length;
    const bfiVerifiedCount = verifiedExperience.filter((b) => b.experienceTypeId != ExperienceType.NonBfi).length;

    const label =
        count === 0 ? `No ${propertiesVerified}` : count === 1 ? `1 ${propertyVerified}` : `${count} ${propertiesVerified}`;

    const labelNonBFIVerified =
        nonBFIVerifiedCount === 0
            ? `No Non-BFI ${propertiesVerified}.`
            : count === 1
              ? `1 Non-BFI ${propertyVerified}.`
              : `${nonBFIVerifiedCount} Non-BFI ${propertiesVerified}.`;

    const labelBFIVerified =
        bfiVerifiedCount === 0
            ? `No BFI ${propertiesVerified}.`
            : count === 1
              ? `1 BFI ${propertyVerified}.`
              : `${bfiVerifiedCount} BFI ${propertiesVerified}.`;

    return (
        <>
            <div className={`experience-header-title ${mobileScreen ? 'mobile' : ''}`}>
                <h2>{label}</h2>
                <div className={`experience-header-title-subtitle ${mobileScreen ? 'mobile' : ''}`}>
                    <span>{labelNonBFIVerified}</span>
                    <span>{labelBFIVerified}</span>
                </div>
            </div>
        </>
    );
};
